import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { StrictMode } from "react";
import { ErrorBoundary } from "./components/error-boundary";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./lib/msalInstance";
import { ThemeProvider } from "@/components/theme/ThemeProvider";
import { initSentry } from "./lib/sentry";

// Sentry must initialize before any error is thrown to be captured.
// Inert if VITE_SENTRY_DSN is not set (e.g. local dev without DSN).
initSentry();

// Clear any storage that might affect the app
localStorage.removeItem('dataverse_use_in_memory');
sessionStorage.removeItem('dataverse_use_in_memory');

// Render the app with Azure authentication via MSAL
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <MsalProvider instance={msalInstance}>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </MsalProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>
);
